import { SUPABASE_URL, getDbHeaders } from "./client";

// Record that the current partner has viewed a broadcast message.
// Uses upsert to be idempotent — safe to call on every thread open.
export async function dbRecordBroadcastReceipt(messageId, airline) {
  await fetch(SUPABASE_URL + "/rest/v1/broadcast_receipts", {
    method: "POST",
    headers: await getDbHeaders({ "Prefer": "resolution=ignore-duplicates,return=minimal" }),
    body: JSON.stringify({ message_id: messageId, airline }),
  });
}

// Load receipts for a set of message IDs (partners see their own via RLS; UA sees all).
export async function dbLoadBroadcastReceipts(messageIds) {
  if (!messageIds || !messageIds.length) return [];
  const list = messageIds.join(",");
  const res = await fetch(
    SUPABASE_URL + "/rest/v1/broadcast_receipts?message_id=in.(" + list + ")&select=message_id,airline,read_at&order=read_at.asc",
    { headers: await getDbHeaders() }
  );
  if (!res.ok) return [];
  return res.json();
}
